import loadable from '@loadable/component';
import Loading from '../components/Loader';

const SimilarBusinesses = loadable(
  () => import(/* webpackChunkName: "sim-bis" */ '../containers/SimilarBusinesses'),
  {
    fallback: Loading
  }
);

SimilarBusinesses.needs = () => {
  SimilarBusinesses.preload();
};

export default SimilarBusinesses;
